import { Field, makeStyles, SpinButton, tokens } from '@fluentui/react-components';
import { useT } from '@powerportalspro/react';
import { Section, SectionColumn } from '@powerportalspro/react-fluent';
import { useState } from 'react';

const STRINGS_BASE =
  'components.PowerPortalsPro.Demo.Client.Customizations.Pages.Layout.Section.SectionColumnWidthsDemo';

const useStyles = makeStyles({
  toolbar: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: tokens.spacingHorizontalL,
  },
  inlineField: {
    flexShrink: 0,
    gridTemplateColumns: 'auto auto',
    '& label': { whiteSpace: 'nowrap' },
  },
  numberInput: { width: '90px' },
  minWidthInput: { width: '120px' },
});

function readSpinValue(value: number | null | undefined, displayValue: string | undefined) {
  if (typeof value === 'number' && Number.isFinite(value)) return value;
  const parsed = Number(displayValue);
  return Number.isFinite(parsed) ? parsed : undefined;
}

export function SectionColumnWidthsSample() {
  const styles = useStyles();
  const t = useT();
  const [width1, setWidth1] = useState(3);
  const [width2, setWidth2] = useState(4);
  const [width3, setWidth3] = useState(3);
  const [columnMinWidth, setColumnMinWidth] = useState(200);

  const formatLabel = (width: number) => {
    const total = width1 + width2 + width3;
    if (total <= 0) return '0%';
    return `${((width / total) * 100).toFixed(1)}%`;
  };

  return (
    <Section>
      <SectionColumn
        header={
          <div className={styles.toolbar}>
            <Field
              label={t(`${STRINGS_BASE}.column1-width`)}
              orientation="horizontal"
              className={styles.inlineField}
            >
              <SpinButton
                className={styles.numberInput}
                value={width1}
                onChange={(_, d) => {
                  const n = readSpinValue(d.value, d.displayValue);
                  if (n !== undefined) setWidth1(n);
                }}
              />
            </Field>
            <Field
              label={t(`${STRINGS_BASE}.column2-width`)}
              orientation="horizontal"
              className={styles.inlineField}
            >
              <SpinButton
                className={styles.numberInput}
                value={width2}
                onChange={(_, d) => {
                  const n = readSpinValue(d.value, d.displayValue);
                  if (n !== undefined) setWidth2(n);
                }}
              />
            </Field>
            <Field
              label={t(`${STRINGS_BASE}.column3-width`)}
              orientation="horizontal"
              className={styles.inlineField}
            >
              <SpinButton
                className={styles.numberInput}
                value={width3}
                onChange={(_, d) => {
                  const n = readSpinValue(d.value, d.displayValue);
                  if (n !== undefined) setWidth3(n);
                }}
              />
            </Field>
            <Field
              label={t(`${STRINGS_BASE}.column-min-width`)}
              orientation="horizontal"
              className={styles.inlineField}
            >
              <SpinButton
                className={styles.minWidthInput}
                min={0}
                value={columnMinWidth}
                onChange={(_, d) => {
                  const n = readSpinValue(d.value, d.displayValue);
                  if (n !== undefined) setColumnMinWidth(n);
                }}
              />
            </Field>
          </div>
        }
      >
        <Section columnMinWidth={`${columnMinWidth}px`}>
          <SectionColumn borderVisible width={width1}>
            {formatLabel(width1)}
          </SectionColumn>
          <SectionColumn borderVisible width={width2}>
            {formatLabel(width2)}
          </SectionColumn>
          <SectionColumn borderVisible width={width3}>
            {formatLabel(width3)}
          </SectionColumn>
        </Section>
      </SectionColumn>
    </Section>
  );
}
